import { createElement } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Icon } from '../../display/Icon/Icon.es.js';
import { ServiceIcon } from '../../patterns/ServiceIcon/ServiceIcon.es.js';

const root = "_root_1eqo5_1";
const step = "_step_1eqo5_7";
const stepName = "_step-name_1eqo5_22";
const divider = "_divider_1eqo5_31";
const styles = {
	root: root,
	step: step,
	stepName: stepName,
	divider: divider
};

const ZapCardStep = (props) => {
  const isTrigger = props.index === 0;
  const divider = !isTrigger && jsx("div", { className: styles.divider, "data-zds": true, children: jsx(Icon, { color: "GrayWarm2", name: "formAddCircle", size: 18 }) });
  return jsxs("li", { className: styles.step, "data-zds": true, children: [divider, jsx(ServiceIcon, { "aria-hidden": true, serviceName: props.name, size: "medium", src: props.icon }), jsxs("div", { "data-zds": true, children: [jsx("p", { "data-zds": true, children: isTrigger ? "When this happens" : "Then do this" }), jsxs("p", { className: styles.stepName, "data-zds": true, children: ["Step ", props.index + 1, ": ", props.label] })] })] });
};
const ZapCardSteps = (props) => {
  return jsx("ol", { className: styles.root, children: props.steps.map((step, i) => {
    return createElement(ZapCardStep, Object.assign({}, step, { index: i, key: i }));
  }) });
};

export { ZapCardSteps };
//# sourceMappingURL=ZapCardSteps.es.js.map
